import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

interface ListTableRow {
  name: string;
  items: number;
  link: string;
}

@Component({
  selector: 'app-list-table',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="table-card">
      <h2 class="table-title">{{ title() }}</h2>

      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Itens</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.name) {
              <tr>
                <td>{{ row.name }}</td>
                <td>{{ row.items }}</td>
                <td><a [routerLink]="row.link">Abrir</a></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  `,
  styles: [
    `
      .table-card {
        border: 1px solid var(--border);
        border-radius: 14px;
        background: var(--surface-elevated);
        padding: 16px;
        box-shadow: var(--shadow-card);
      }

      .table-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--text);
        margin-bottom: 12px;
      }

      .table-wrap {
        overflow-x: auto;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th,
      td {
        padding: 10px 0;
        border-bottom: 1px solid var(--border);
        text-align: left;
        color: var(--text);
        font-size: 14px;
      }

      th {
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: var(--faint);
      }

      tbody tr:last-child td {
        border-bottom: 0;
      }

      a {
        color: var(--active-text);
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }
    `,
  ],
})
export class ListTableComponent {
  readonly title = input<string>('Listas do projeto');
  readonly rows = input<ListTableRow[]>([]);
}

export type { ListTableRow };
